<template>
  <div class="container-fluid">
    <span class="resize-loading" v-if="!customer">
      <span class="loader"></span>
    </span>
    <customer-form
      v-if="customer"
      :loading="loading"
      :customerData="customer"
      :formErrors="formErrors"
      @customerSubmitted="handleSubmit"
      @formChanged="() => (alertLeave = true)"
      :billing-address-same-as-customer-value="false"
    />
  </div>
</template>

<script>
import CustomerForm from "../partials/CustomerForm.vue";
import { cloneDeep } from "lodash";
import alertLeave from "@/mixins/alert-leave-mixin";
import requestErrorMixin from "@/mixins/request-error-mixin";

export default {
  layout: "DashboardLayout",

  components: { CustomerForm },

  mixins: [alertLeave, requestErrorMixin],

  props: {
    customerId: {
      type: [String, Number],
      required: true,
    },
  },

  data() {
    return {
      customer: null,
      formErrors: null,
      loading: false,
    };
  },

  created() {
    this.get();
  },

  methods: {
    async get() {
      this.loading = true;
      try {
        await this.$store.dispatch("customers/get", this.customerId);
        this.customer = this.$store.getters["customers/customer"];
        this.loading = false;
      } catch (error) {
        this.showRequestError(error);
        this.$notify({
          type: "danger",
          message: `Oops, something went wrong!`,
        });
        this.loading = false;
      }
    },

    async handleSubmit(customer) {
      this.loading = true;
      const customerData = cloneDeep(customer);

      try {
        await this.$store.dispatch("customers/update", customerData);
        this.$notify({
          type: "success",
          timeout: 3000,
          message: this.$t("CUSTOMERS.CUSTOMER_UPDATED"),
        });
        const customer = await this.$store.getters["customers/customer"];
        this.$emit("onViewCustomer", customer, true);
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.formErrors = error.response.data.errors;
        this.loading = false;
      }
    },
  },
};
</script>
